import { render, staticRenderFns } from "./ReservationPage.vue?vue&type=template&id=5246138c&scoped=true"
import script from "./ReservationPage.vue?vue&type=script&lang=js"
export * from "./ReservationPage.vue?vue&type=script&lang=js"
import style0 from "./ReservationPage.vue?vue&type=style&index=0&id=5246138c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5246138c",
  null
  
)

export default component.exports